<template>
  <div class="page bg-color">
    <div class="mine-user">
      <img src="@/assets/images/mine-icon-36.png" alt="">
      <div class="mine-user-name"> {{ maskString(loginInfo.username) }} </div>
      <div class="mine-user-active">
        <div class="mine-user-active-box" v-if="userInfo.is_realname || userInfo.is_realname == 0"
          :style="`background-color:${userInfo.is_realname != 1 ? '#eee' : ''}`"
          @click="router.push('/realNameAuthentication')">
          <img v-if="userInfo.is_realname == 1" src="@/assets/images/aq.svg">
          <img v-else-if="userInfo.is_realname == 0 && userInfo.card_id" src="@/assets/images/wtg.svg">
          <img v-else src="@/assets/images/wsm.png">
          <div v-if="userInfo.is_realname == 1"> {{ t('mine.a1') }} </div>
          <div v-else-if="userInfo.is_realname == 2" style="color: #ff991a;"> {{ t('mine.a10') }} </div>
          <div v-else-if="userInfo.is_realname == 0 && userInfo.card_id" style="color: #f14950;"> {{ t('mine.a11') }}
          </div>
          <div v-else style="color: #999999;"> {{ t('mine.a12') }} </div>
        </div>
      </div>
    </div>
    <div class="mine-balance">
      <div class="mine-balance-box">
        <div class="mine-balance-box-con">
          <div class="mine-con-head"><img src="@/assets/images/kyzj.png" alt="" class="mine-con-head-img1">
            <div>{{ t('mine.a2') }}(USD)</div>
            <!-- <img @click="router.push('/assetConversion')" src="@/assets/images/jh.png" alt="" class="mine-con-head-img2"> -->
          </div>
          <div class="mine-con-num"> ${{ userInfo.balance_ar }} </div>
          <!-- <div class="yval"> ≈ {{ formatUnit('USD') }} {{ exchangeRateConvert(userInfo.balance_ar, rate, true) }}</div> -->
        </div>
        <!-- <div class="mine-balance-box-xian"></div>
        <div class="mine-balance-box-con">
          <div class="mine-con-head"><img src="@/assets/images/kyzj2.png" alt="" class="mine-con-head-img1">
            <div>{{t('mine.a3')}}(USD)</div><img @click="router.push('/assetConversion')" src="@/assets/images/jh.png" alt=""
              class="mine-con-head-img2">
          </div>
          <div class="mine-con-num"> 959,657.66 $ </div>
        </div> -->
      </div>
    </div>
    <div class="mine-menu">
      <div class="mine-menu-box" @click="router.push('/realNameAuthentication')">
        <img src="@/assets/images/mi1.svg" alt="" class="mine-menu-box-img1">
        <div>{{ t('mine.a4') }}</div>
        <img src="@/assets/images/rgjt.png" alt="" class="mine-menu-box-img2">
      </div>
      <div class="mine-menu-box" @click="router.push('/updateLoginPassword')">
        <img src="@/assets/images/mi2.svg" alt="" class="mine-menu-box-img1">
        <div>{{ t('mine.a5') }}</div>
        <img src="@/assets/images/rgjt.png" alt="" class="mine-menu-box-img2">
      </div>
      <div class="mine-menu-box" @click="router.push('/fundAccountManage')">
        <img src="@/assets/images/mi3.svg" alt="" class="mine-menu-box-img1">
        <div>{{ t('mine.a6') }}</div>
        <img src="@/assets/images/rgjt.png" alt="" class="mine-menu-box-img2">
      </div>
      <div class="mine-menu-box" @click="openService">
        <img src="@/assets/images/mi4.svg" alt="" class="mine-menu-box-img1">
        <div>{{ t('mine.a7') }}</div>
        <img src="@/assets/images/rgjt.png" alt="" class="mine-menu-box-img2">
      </div>
      <div class="mine-menu-box" @click="router.push('/antiFraud')">
        <img src="@/assets/images/mi7.svg" alt="" class="mine-menu-box-img1">
        <div>{{ t('mine.a13') }}</div>
        <img src="@/assets/images/rgjt.png" alt="" class="mine-menu-box-img2">
      </div>
      <div class="mine-menu-box" @click="router.push('/Regulatorynfo')">
        <img src="@/assets/images/mi10.svg" alt="" class="mine-menu-box-img1">
        <div>{{t('mine.a14')}}</div>
        <img src="@/assets/images/rgjt.png" alt="" class="mine-menu-box-img2">
      </div>
      <div class="mine-menu-box" @click="router.push('/riskDisclosure')">
        <img src="@/assets/images/mi11.svg" alt="" class="mine-menu-box-img1">
        <div>{{t('mine.a15')}}</div>
        <img src="@/assets/images/rgjt.png" alt="" class="mine-menu-box-img2">
      </div>
      <div class="mine-menu-box" @click="openPopup">
        <img src="@/assets/images/mi5.svg" alt="" class="mine-menu-box-img1">
        <div>{{ t('mine.a8') }}</div>
        <img src="@/assets/images/rgjt.png" alt="" class="mine-menu-box-img2">
      </div>
      <div class="mine-menu-box" @click="LogOut">
        <img src="@/assets/images/mi6.svg" alt="" class="mine-menu-box-img1">
        <div>{{ t('mine.a9') }}</div>
        <img src="@/assets/images/rgjt.png" alt="" class="mine-menu-box-img2">
      </div>
    </div>

  </div>
</template>

<script setup name="minePage">
import { closeWS } from '@/ws'
import { formatUnit, exchangeRateConvert } from "@/utils/globalMethods"
import { useRouter } from "vue-router";
import { onMounted, ref, onActivated, onDeactivated } from "vue";
import { useMainStore } from "@/store"
import { eventBus } from '@/utils/eventBus'
import { useI18n } from "vue-i18n"
const { t } = useI18n()
const mainStore = useMainStore()

const rate = computed(() => mainStore.rate)

// 客服
const service = computed(() => mainStore.service)
const openService = () => {
  eventBus.emit("openService", service.value)
}

const openPopup = () => {
  eventBus.emit("toggleLangPopup", true)
}

const loginInfo = computed(() => mainStore.loginInfo)
const userInfo = ref({})
const router = useRouter()
function LogOut() {
  closeWS()
  mainStore.removeStore()
  router.push('/')
}

function getUserInfo() {
  mainStore.getUserInfo().then(data => {
    userInfo.value = data
  })
}


function maskString(str) {
  if (!str) return "";

  const start = str.slice(0, 3);
  const end = str.slice(-4);

  return `${start}****${end}`;
}
function initPageApi() {
  getUserInfo()
}
onActivated(() => {
  initPageApi()
})
onDeactivated(() => {
  console.log('deactivated')
})

</script>
<style scoped lang="scss">
.page {
  min-height: 100vh;
  padding: 20px 20px 75px 20px;

  .mine-user {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    img {
      width: 48px;
      height: 48px;
      border-radius: 100%;
    }

    .mine-user-name {
      color: #000;
      font-family: Montserrat;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 18px;
      letter-spacing: -.165px;
      width: 100px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .mine-user-active {
      flex: 1;
      display: flex;
      align-items: center;

      .mine-user-active-box {
        background-color: #e5ebfb;
        padding: 8px 15px;
        line-height: 0;
        border-radius: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 5px;

        img {
          width: 16px;
          height: 16px;
        }

        div {
          font-size: 14px;
          color: #2969FF;
        }
      }
    }
  }

  .mine-balance {
    margin-top: 16px;
    background-color: #fff;
    border-radius: 8px;
    padding: 16px 14px;

    .mine-balance-box {
      display: flex;
      justify-content: space-between;
      gap: 20px;

      .mine-balance-box-con {
        flex: 1;

        .mine-con-head {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 6px;

          .mine-con-head-img1 {
            width: 20px;
            height: 20px;
          }

          div {
            flex: 1;
            font-size: 12px;
            font-weight: 500;
            color: #000;
          }

          .mine-con-head-img2 {
            width: 14px;
            height: 14px;
          }
        }

        .mine-con-num {
          font-size: 16px;
          font-weight: 700;
          color: #000;
          margin-top: 10px;
        }

        .yval {
          font-size: 12px;
          color: #888c9f;
          margin-top: 6px;
          font-weight: 400;
        }
      }

      .mine-balance-box-xian {
        width: 2px;
        height: auto;
        background: rgba(0, 60, 210, .1);
      }

      .mine-balance-box-con {
        flex: 1;
      }
    }
  }

  .mine-menu {
    margin-top: 16px;

    .mine-menu-box {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      padding: 16px 0;
      border-bottom: 1px solid rgba(0, 60, 210, .1);

      .mine-menu-box-img1 {
        width: 22px;
        height: 22px;
      }

      div {
        flex: 1;
        font-size: 14px;
        font-weight: 400;
        color: #000;
      }

      .mine-menu-box-img2 {
        width: 5px;
        height: 11px;
      }
    }
  }
}
</style>
